module.exports = __webpack_public_path__ + "static/media/clear-2.460bc19c.png";